import { toWSDateString } from "@wingspanhq/fe-component-library";
import {
  PayableRow,
  SearchPayableRowsFilterParameter
} from "@wingspanhq/wingspan-api-sdk";
import { queriesPayableRows } from "@query";
import { selectorSearchRowName } from "../../../../shared/selectors/selectorSearchRowName";

const PAGE_SIZE = 100;
const MAX_PAGES = 200;

type CsvRow = {
  "Payable ID": string;
  "Invoice #": string;
  Contractor: string;
  Email: string;
  Amount: number | string;
  Currency: string;
  "Due date": string;
  "Paid date": string;
  Status: string;
};

const toCsvRow = (payable: PayableRow): CsvRow => ({
  "Payable ID": payable.id ?? "",
  "Invoice #": payable.invoiceNumber ?? "",
  Contractor: selectorSearchRowName(payable),
  Email: payable.email ?? "",
  Amount: payable.amount ?? "",
  Currency: payable.currency?.toUpperCase() ?? "",
  "Due date": payable.dueDate ? toWSDateString(payable.dueDate, "input") : "",
  "Paid date": payable.events?.paidAt
    ? toWSDateString(payable.events.paidAt, "input")
    : "",
  Status: payable.status ?? ""
});

/**
 * Fetches every page of a filtered `searchPayableRows` result and returns
 * plain row objects — the shape `ButtonDownloadCsv`/`CSVLink` expects.
 * The v1 `DownloadCsv.tsx` this replaces looped `paymentsService.payable.list`
 * the same way; this is that same loop against the v3 registry.
 */
export const getClientPayablesCsvData = async (
  filter: SearchPayableRowsFilterParameter
): Promise<CsvRow[]> => {
  const collected: PayableRow[] = [];
  let token: string | undefined;
  let pageCount = 0;

  do {
    pageCount++;
    const page = await queriesPayableRows.searchPayableRows.fetchQueryData({
      filter,
      page: { size: PAGE_SIZE, token }
    });
    collected.push(...(page.data ?? []));
    token = page.pagination?.nextPageToken ?? undefined;
  } while (token && pageCount < MAX_PAGES);

  return collected.map(toCsvRow);
};
